/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderRequestPost } from '../../models/create-order-request-post';
import { CreateOrderResponse } from '../../models/create-order-response';

export interface OrdersControllerCreateOrder$Params {
      body: CreateOrderRequestPost
}

export function ordersControllerCreateOrder(http: HttpClient, rootUrl: string, params: OrdersControllerCreateOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderResponse>> {
  const rb = new RequestBuilder(rootUrl, ordersControllerCreateOrder.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOrderResponse>;
    })
  );
}

ordersControllerCreateOrder.PATH = '/planning-projects/v1-develop/orders';
